module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "modal"
  }, [_c('div', {
    staticClass: "modal__overlay",
    on: {
      "click": function($event) {
        _vm.$emit('close')
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "modal__box"
  }, [_c('div', {
    staticClass: "modal__close-button",
    on: {
      "click": function($event) {
        _vm.$emit('close')
      }
    }
  }, [_c('div', {
    staticClass: "modal__close-icon"
  }, [_c('IconX')], 1)]), _vm._v(" "), _c('div', {
    staticClass: "modal__box-inner",
    attrs: {
      "id": "modal-scroll"
    }
  }, [_c('div', {
    staticClass: "modal__main"
  }, [_c(_vm.currentComponent, {
    tag: "component",
    attrs: {
      "args": _vm.modalArguments
    }
  })], 1)])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-c1774b30","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./source/js/components/Modal.vue
// module id = 78
// module chunks = 1